import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { routes } from './app-routing.module';
import { environment } from '../environments/environment';
import { AuthGuard } from '@angular/fire/auth-guard';
import { AuthService } from './services/auth.service';
import { ItemsService } from './services/items.service';
import { OffersService } from './services/offers.service';
import { PaymentsService } from './services/payments.service';
import { UsersService } from './services/users.service';
import { provideHttpClient } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideNativeDateAdapter(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideDatabase(() => getDatabase()),
    provideStorage(() => getStorage()),
    AuthGuard,
    AuthService,
    ItemsService,
    OffersService,
    PaymentsService,
    UsersService
  ]
};
